var _rect, _g, _rect2, _g2, _rect3, _g3, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGymFitnessBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 74,
    viewBox: "0 0 335 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19491_32724)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "url(#paint0_linear_19491_32724)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#clip1_19491_32724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.5 43.0004C237.982 43.0004 236.75 44.2324 236.75 45.7504V67.7504C236.75 69.2656 235.515 70.5004 234 70.5004C232.485 70.5004 231.25 69.2656 231.25 67.7504V59.5004V15.5004V7.25037C231.25 5.73512 232.485 4.50037 234 4.50037C235.515 4.50037 236.75 5.73512 236.75 7.25037V26.5004C236.75 28.0184 237.982 29.2504 239.5 29.2504C241.018 29.2504 242.25 28.0184 242.25 26.5004V7.57487C242.25 3.58462 239.56 -0.0811274 235.645 -0.840127C230.378 -1.86313 225.75 2.16287 225.75 7.25037V7.75637C223.643 7.00562 221.229 6.90662 218.501 8.74087C216.128 10.3386 214.75 13.0749 214.75 15.9376V16.0064C212.949 15.3656 210.922 15.1979 208.667 16.3116C205.571 17.8406 203.75 21.1544 203.75 24.6084V32.0004C202.232 32.0004 201 33.2324 201 34.7504V40.2504C201 41.7684 202.232 43.0004 203.75 43.0004V50.3924C203.75 53.8464 205.571 57.1629 208.667 58.6919C210.922 59.8029 212.949 59.6351 214.75 58.9944V59.0631C214.75 61.9259 216.128 64.6621 218.501 66.2599C221.229 68.0941 223.643 67.9951 225.75 67.2444V67.4259C225.75 71.4161 228.44 75.0819 232.356 75.8409C237.622 76.8639 242.25 72.8379 242.25 67.7504V48.4949C242.959 48.5004 243.757 48.5004 244.656 48.5004H272.5C274.018 48.5004 275.25 47.2684 275.25 45.7504C275.25 44.2324 274.035 43.0004 272.517 43.0004C264.22 43.0004 239.866 43.0004 239.511 43.0004H239.5ZM212 54.0004C210.485 54.0004 209.25 52.7656 209.25 51.2504V23.7504C209.25 22.2351 210.485 21.0004 212 21.0004C213.515 21.0004 214.75 22.2351 214.75 23.7504V51.2504C214.75 52.7656 213.515 54.0004 212 54.0004ZM223 62.2504C221.485 62.2504 220.25 61.0156 220.25 59.5004V51.2504V23.7504V15.5004C220.25 13.9851 221.485 12.7504 223 12.7504C224.515 12.7504 225.75 13.9851 225.75 15.5004V59.5004C225.75 61.0156 224.515 62.2504 223 62.2504Z",
    fill: "#BF791E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.25 32V23.75C319.25 19.2015 315.549 15.5 311 15.5C310.032 15.5 309.113 15.698 308.25 16.006V15.5C308.25 10.9515 304.549 7.25 300 7.25C299.032 7.25 298.113 7.448 297.25 7.756V7.25C297.25 2.7015 293.549 -1 289 -1C284.451 -1 280.75 2.7015 280.75 7.25V23.75H250.5C248.982 23.75 247.75 24.982 247.75 26.5C247.75 28.018 248.982 29.25 250.5 29.25H283.494H283.5C285.018 29.25 286.25 28.018 286.25 26.5V7.25C286.25 5.73475 287.485 4.5 289 4.5C290.515 4.5 291.75 5.73475 291.75 7.25V15.5V59.5V67.75C291.75 69.2653 290.515 70.5 289 70.5C287.485 70.5 286.25 69.2653 286.25 67.75V45.75C286.25 44.232 285.018 43 283.5 43C281.982 43 280.75 44.232 280.75 45.75V67.75C280.75 72.2985 284.451 76 289 76C293.549 76 297.25 72.2985 297.25 67.75V67.244C298.113 67.552 299.032 67.75 300 67.75C304.549 67.75 308.25 64.0485 308.25 59.5V58.994C309.113 59.302 310.032 59.5 311 59.5C315.549 59.5 319.25 55.7985 319.25 51.25V43C320.768 43 322 41.768 322 40.25V34.75C322 33.232 320.768 32 319.25 32ZM302.75 59.5C302.75 61.0153 301.515 62.25 300 62.25C298.485 62.25 297.25 61.0153 297.25 59.5V15.5C297.25 13.9847 298.485 12.75 300 12.75C301.515 12.75 302.75 13.9847 302.75 15.5V23.75V51.25V59.5ZM313.75 51.25C313.75 52.7653 312.515 54 311 54C309.485 54 308.25 52.7653 308.25 51.25V23.75C308.25 22.2348 309.485 21 311 21C312.515 21 313.75 22.2348 313.75 23.75V51.25Z",
    fill: "#BF791E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19491_32724",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 74
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.973633,
    width: 335,
    height: 73.0263,
    rx: 12,
    fill: "url(#paint1_linear_19491_32724)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19491_32724)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_19491_32724",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 74
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 0.973633,
    width: 335,
    height: 73.0263,
    rx: 12,
    fill: "url(#paint2_linear_19491_32724)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_19491_32724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4 20.4211C81.4937 41.4521 71.1769 65.7578 49.3485 74.7061C27.5201 83.6544 2.45541 73.8531 -6.63837 52.822C-15.7322 31.791 -5.41527 7.48529 16.4131 -1.46303C38.2415 -10.4113 63.3062 -0.609987 72.4 20.4211Z",
    stroke: "url(#paint3_linear_19491_32724)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6318 23.1957C73.1204 40.5145 64.5329 60.5696 46.4413 67.986C28.3497 75.4025 7.61608 67.3673 0.127483 50.0486C-7.36112 32.7298 1.22636 12.6748 19.318 5.2583C37.4096 -2.15817 58.1432 5.87698 65.6318 23.1957Z",
    stroke: "url(#paint4_linear_19491_32724)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8657 25.9716C64.7491 39.5782 57.8913 55.3833 43.5357 61.2682C29.1801 67.1532 12.7772 60.8836 6.89369 47.2769C1.0102 33.6703 7.86805 17.8652 22.2237 11.9803C36.5793 6.09534 52.9822 12.3649 58.8657 25.9716Z",
    stroke: "url(#paint5_linear_19491_32724)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1014 28.7472C56.3794 38.6407 51.2522 50.1957 40.6324 54.5491C30.0126 58.9026 17.9414 54.398 13.6635 44.5045C9.38552 34.611 14.5127 23.056 25.1325 18.7026C35.7522 14.3491 47.8235 18.8537 52.1014 28.7472Z",
    stroke: "url(#paint6_linear_19491_32724)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3314 31.5211C48.0033 37.7004 44.609 45.0065 37.7229 47.8294C30.8368 50.6523 23.0977 47.9102 20.4258 41.7309C17.7538 35.5516 21.1481 28.2455 28.0342 25.4226C34.9204 22.5997 42.6595 25.3418 45.3314 31.5211Z",
    stroke: "url(#paint7_linear_19491_32724)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0221 33.4026C40.3432 36.4579 38.8714 39.9804 35.7295 41.2683C32.5877 42.5563 28.9716 41.1195 27.6505 38.0643C26.3294 35.0091 27.8012 31.4866 30.943 30.1986C34.0848 28.9107 37.701 30.3474 39.0221 33.4026Z",
    stroke: "url(#paint8_linear_19491_32724)",
    strokeWidth: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M357.642 52.9298C361.879 62.7291 357.072 74.0568 346.898 78.2277C336.724 82.3985 325.044 77.8294 320.806 68.0301C316.569 58.2308 321.376 46.9031 331.55 42.7322C341.724 38.5613 353.405 43.1305 357.642 52.9298Z",
    stroke: "url(#paint9_linear_19491_32724)",
    strokeOpacity: 0.4,
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M354.479 54.2276C357.966 62.2919 353.968 71.6334 345.54 75.0886C337.111 78.5438 327.455 74.7996 323.968 66.7353C320.481 58.671 324.479 49.3294 332.907 45.8742C341.336 42.419 350.992 46.1632 354.479 54.2276Z",
    stroke: "url(#paint10_linear_19491_32724)",
    strokeOpacity: 0.4,
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M351.317 55.5244C354.054 61.8537 350.865 69.2095 344.182 71.9492C337.499 74.6889 329.866 71.7691 327.13 65.4398C324.393 59.1106 327.582 51.7548 334.265 49.0151C340.948 46.2754 348.58 49.1952 351.317 55.5244Z",
    stroke: "url(#paint11_linear_19491_32724)",
    strokeOpacity: 0.4,
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M348.154 56.8212C350.141 61.4146 347.761 66.7848 342.823 68.8091C337.885 70.8335 332.277 68.7374 330.291 64.144C328.305 59.5507 330.684 54.1805 335.622 52.1561C340.561 50.1317 346.168 52.2278 348.154 56.8212Z",
    stroke: "url(#paint12_linear_19491_32724)",
    strokeOpacity: 0.4,
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M344.993 58.1171C346.228 60.9733 344.661 64.3589 341.465 65.6687C338.27 66.9786 334.688 65.7038 333.453 62.8476C332.218 59.9915 333.785 56.6059 336.98 55.296C340.175 53.9862 343.758 55.2609 344.993 58.1171Z",
    stroke: "url(#paint13_linear_19491_32724)",
    strokeOpacity: 0.4,
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19491_32724",
    x1: 3.5,
    y1: 6.16667,
    x2: 321.533,
    y2: 135.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9A9",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE5C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19491_32724",
    x1: 3.5,
    y1: 7.05917,
    x2: 320.323,
    y2: 137.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD9A9",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19491_32724",
    x1: 3.5,
    y1: 7.05917,
    x2: 320.323,
    y2: 137.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD9A9",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19491_32724",
    x1: 66.9615,
    y1: 65.4598,
    x2: 52.1755,
    y2: 3.80078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D59540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC881",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19491_32724",
    x1: 61.0563,
    y1: 60.3445,
    x2: 48.8231,
    y2: 9.54328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D59540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC881",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19491_32724",
    x1: 55.153,
    y1: 55.2312,
    x2: 45.4732,
    y2: 15.2866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D59540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC881",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19491_32724",
    x1: 49.2517,
    y1: 50.1168,
    x2: 42.1277,
    y2: 21.0303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D59540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC881",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19491_32724",
    x1: 43.3445,
    y1: 45.0015,
    x2: 38.781,
    y2: 26.7723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D59540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC881",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_19491_32724",
    x1: 38.3315,
    y1: 39.9952,
    x2: 36.1671,
    y2: 30.9066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D59540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC881",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_19491_32724",
    x1: 355.15,
    y1: 73.9559,
    x2: 348.24,
    y2: 45.1431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A96812"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_19491_32724",
    x1: 352.39,
    y1: 71.5667,
    x2: 346.674,
    y2: 47.8277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A96812"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_19491_32724",
    x1: 349.632,
    y1: 69.177,
    x2: 345.108,
    y2: 50.5112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A96812"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_19491_32724",
    x1: 346.872,
    y1: 66.7868,
    x2: 343.543,
    y2: 53.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A96812"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_19491_32724",
    x1: 344.113,
    y1: 64.3962,
    x2: 341.981,
    y2: 55.8778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A96812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19491_32724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_19491_32724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 121,
    fill: "white",
    transform: "translate(201 -45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymFitnessBg);
export default __webpack_public_path__ + "static/media/Gym-fitness-bg.cb0b3f0f420b8f09679cde219e4d03fe.svg";
export { ForwardRef as ReactComponent };